var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-block" },
    [
      _vm.$userIsAdmin
        ? _c("profile-talent-stats", {
            attrs: { stats: _vm.user.talent_stats },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h2", [_vm._v("Public Details")]),
      _vm._v(" "),
      _c("profile-talent-tagline"),
      _vm._v(" "),
      !_vm.$hideSocialMediaReferences
        ? _c("profile-talent-social-media")
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "margin-20" }),
      _vm._v(" "),
      _c("h3", [_vm._v("Visibility")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Control where you will show up in searches and the services and packages you offer through " +
            _vm._s(_vm.clientName)
        ),
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "item-detail item-detail-simple" },
        _vm._l(_vm.links, function (link) {
          return _c(
            "li",
            {
              key: link.name,
              on: {
                click: () => {
                  _vm.trackSectionClick(link.name)
                },
              },
            },
            [
              _c("router-link", { attrs: { to: link.route } }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-8" }, [
                    _c("h3", { staticClass: "has-sub" }, [
                      _vm._v(_vm._s(link.heading)),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "sub-text" }, [
                      _vm._v(_vm._s(link.description)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-4" }, [
                    _c("div", { staticClass: "actions pull-right" }, [
                      _c("span", { staticClass: "btn btn-info" }, [
                        _c("i", { staticClass: "fa fa-pencil" }),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.$vlastMode && _vm.clientName === "NRL" && _vm.$userIsAdmin
        ? _c("profile-talent-vlast-pdf-download")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }